import { AsyncState, unloadedAsyncState } from "widgets-for-react"
import { ImageSizesProps } from "../modernBlocks/modernBlocks.state"

export type PopupState = {
  popups: AsyncState<Array<DrupalPopup>>
  preview: boolean
}

export type DrupalPopup = {
  Id: string
  NodeId: string
  Title: string
  Intro: string
  PrimaryButton: LinkRef | undefined
  SecondaryButton: LinkRef | undefined
  Language: string
  LastUpdated: Date
  Created: Date
  Position: PopupPosition
  open: boolean
} & ImageSizesProps

type PopupPosition = 
  | "center"
  | "topright"
  | "topleft"
  | "bottomright"
  | "bottomleft"

type LinkRef = {
  Title: string
  Url: string
}

export const initPopupState = (): PopupState => ({
  popups: unloadedAsyncState(),
  preview: false,
})

